import { Link } from 'react-router-dom'
import netzence from '../../images/Frame 2147228713.png'
import image1 from '../../images//sus3.png'
import image2 from '../../images/sus1.png'
import image3 from '../../images/image 139.png'
import Header from '../shared/Header'
import Footer from '../shared/Footer'
import sportlight from '../../images/TimiAndChuka.png'
import { useEffect } from 'react'

function BlogPost6() {
    useEffect(()=>{
      window.scrollTo(0, 0);
  
  },[])
     const blogs = [
    {
      id: 1,
      badge: "Sustainable Farming",
      badgeColor: "#006633",
      title: "Netzence, Ministry of Livestock Development detect rapid seasonal Methane spikes in livestock systems",
      description: "Nigeria is finally beginning to see what has long remained hidden behind estimates and assumptions: how livestock methane emissions behave...",
      source: "05/02/2026",
      image: image1,
      readMoreLink: "#"
    },
    {
      id: 2,
      badge: "Global Footprint Network",
      badgeColor: "#006633",
      title: "Netzence partners with Ministry of Livestock, Germany’s GIZ to conduct livestock monitoring capacity-building",
      description: "Netzence Sustainability Limited (Netzence) has taken a significant step toward strengthening...",
      source: "30/12/2025",
      image: image2,
      readMoreLink: "#"
    },
    {
      id: 3,
      badge: "Global Footprint Network",
      badgeColor: "#00AED9",
      title: "The United Nations welcomes Netzence Sustainability Limited into the United Nations Global Compact.",
      description: "Netzence Sustainability Limited is proud to announce its official acceptance as a participant in the United Nations Global Compact...",
      source: "18/07/2025",
      image: image3,
      readMoreLink: "#"
    }
  ];
  return (
<>

<Header/> 
<Link to="/blogs">
<div className='ml-72 text-[14px] flex pt-20'>
    Return to blog
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.5 18L15.5 12L9.5 6" stroke="#898989" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


</div>
</Link>
<div className='ml-72 text-[24px] font-bold'>Turning Lagos forests into climate revenue asset  Netzence</div>
<div className='ml-72 flex gap-5 mt-10 '>
    <img src={netzence} alt="netzence" className='w-[48px]' loading="lazy"></img>


    <div>
        <div className='text-[16px] mb-3'>
            Netzence 
        </div>
        <div className='flex items-center gap-3 '>
           September  18, 2025 <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="3" cy="3" r="3" fill="#898989"/>
</svg>
8 mins read
        </div>
    </div>


</div>
<div className='ml-72 mr-72 mt-20'>
    <img src={sportlight} alt="spotlight" className='object-fill w-[1200px]' loading="lazy"></img>
</div>

 <div className="flex flex-col items-start gap-4 w-full max-w-[1152px] h-auto mt-20 ml-72" >
      {/* Paragraph 1 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
In a bid to increase revenue for the country, Netzence sustainability Limited has said that baseline studies and carbon credits could transform Nigeria’s forests and gas flares into global climate-finance opportunities.</p>
      {/* Paragraph 2 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Speaking yesterday the Founder/ Chief Executive Officer of Netzence, Dr. Sadiq Sani said “Air pollution in Lagos has significant health and economic impacts. The World Bank estimates Nigeria loses over six billion dollars annually due to poor air quality, and WHO data links more than 400,000 premature deaths each year to pollution.</p>

      {/* Paragraph 3 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“Diesel emissions, generators, burning refuse and heavy traffic have made Nigeria one of Africa’s most polluted environments. However, the country’s forests continue to provide essential services by filtering air, capturing carbon and supporting public health.</p>

      {/* Paragraph 4 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“But in an era of accelerating climate change, the real story is not only about carbon dioxide. Nigeria must urgently measure and manage methane, an overlooked but devastating greenhouse gas more than 80 times as potent as carbon dioxide over a 20-year period. Methane leaks from oil fields, pipelines, gas-flaring sites, landfills, and agriculture represent both a climate liability and a missed commercial opportunity. Without a credible baseline study of methane emissions, Nigeria is navigating blind in a global race where hard data attracts billions in climate finance.</p>

      {/* Paragraph 5 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“At the Lekki Conservation Centre, measurement efforts are underway. Netzence Sustainability Limited recently deployed a forestry-embedded system to capture real-time greenhouse gas data, including methane, across forest trails. Initial readings were 466 ppm in open-air zones, increasing to 520 ppm in denser areas and reaching 548 ppm in enclosed spots, all above the global average of approximately 420 ppm. These findings highlight that Nigeria’s natural assets are under pressure and require careful monitoring. Accurate data and rigorous oversight are essential to fully understand both the risks and the commercial potential of reducing emissions.</p>

      {/* Paragraph 6 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“Methane is not an abstract problem. Nigeria is Africa’s largest oil and gas producer and one of the world’s top ten countries in terms of gas flaring. Each year, billions of cubic metres of gas are burned off in open flares across the Niger Delta. These flames release not only carbon dioxide but also massive quantities of methane that slip undetected into the atmosphere. A national methane baseline study would provide scientific benchmarks for how much methane Nigeria emits and from which sectors. It would allow the country to participate in emerging methane-specific carbon markets — which often trade at a premium — and it would open the door to clean-tech investments in leak-detection systems, flare-capture projects, and waste-to-energy innovations. Perhaps most importantly, it would strengthen Nigeria’s hand in global climate negotiations, where methane reduction is now a central agenda item under the Global Methane Pledge.  </p>

      {/* Paragraph 7 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“What sets Netzence’s approach apart is not just the science, but the commercialisation that follows. Through CloseCarbon, its home-grown carbon-tracking and incentivization platform, real-time field readings — whether of carbon sequestration in forests or methane emissions in oil fields — can be translated into verified credits. This is where clean air becomes a tradable asset. By monetising the ecosystem services that forests and methane-reduction projects provide, conservation and mitigation shift from being “nice-to-have” environmental work to bankable infrastructure projects. Such credits could fund the upkeep of conservation areas like Lekki, finance methane-capture initiatives in oilfields and landfills, support community livelihoods, and attract foreign investment as global corporations seek credible offsets for their emissions portfolios.</p>
      {/* Paragraph 8 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“The question of credibility, however, remains central. Investors are wary of opaque reporting and unverifiable claims. This is where technology plays a decisive role. By deploying CloseCarbon, every emission reduction is traceable, auditable, and tamper-proof. This combination of science, technology, and finance offers Nigeria a competitive edge. Rather than appealing to donor sympathy, the country can compete on market terms: real-time, data-driven, verifiable, and profitable climate action. As Netzence CEO Dr. Sadiq Sani remarked during the fieldwork: “This forest is not just a conservation zone — it’s a partner in Lagos’ survival. When we measure its carbon, we are measuring how much time the city has left to breathe. The same logic applies to methane — the less we emit, the more time we all gain.</p>

      {/* Paragraph 9 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“The economic case is equally compelling. Air pollution costs Nigeria over six billion dollars annually in lost productivity and healthcare expenses. The average Lagos resident loses between five and seven years of life expectancy due to poor air quality. Yet reducing methane emissions could generate premium carbon credits valued at $20–$40 per tonne, far higher than standard carbon dioxide credits. With proper monitoring and verification, Nigeria could unlock $1–$2 billion annually in carbon finance within the next decade. Every dollar invested in air-quality monitoring and clean-air infrastructure yields an estimated ten dollars in avoided health and productivity costs.</p>
      {/* Paragraph 10 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“The experience at Lekki and Nigeria’s methane challenge demonstrate that forests, fossil fuels, air quality and economic growth are interconnected. In the context of climate change, every tree preserved, every emission reduced and every tonne measured contribute to both resilience and economic opportunity.</p>

      {/* Paragraph 11 */}
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
“For investors, this is both an urgent and attractive opportunity. By conducting methane baseline studies and commercialising clean air, Nigeria can protect public health while opening new avenues for climate finance. This approach positions the country to benefit from emerging global markets.</p>
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
Source</p>
      <p className="text-[#3B3B3B] font-normal text-[18px] leading-[28px] w-full" style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}>
https://www.vanguardngr.com/2025/09/turning-lagos-forests-into-climate-revenue-asset-netzence/</p>

      {/* Paragraph 12 */}

    </div>

   <div className="items-start gap-10 w-full max-w-[1200px] h-[43px] ml-72">
        <h2 
          className="text-[#0D924F] font-bold text-4xl leading-[43px] w-[225px] h-[43px]"
          style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
        >
          Related Blogs
        </h2>
      </div>

     <div className=" items-start gap-10 w-full max-w-[1201px] h-auto mt-20 ">
      {/* Header */}
   
      {/* Cards Container */}
      <div className="flex flex-row items-stretch gap-8 w-full flex-wrap ml-72 lg:flex-nowrap mb-20">
        {blogs.map((blog) => (
          <div 
            key={blog.id}
            className="flex flex-col items-center pb-6 gap-4 w-[379px] h-[544px] bg-white shadow-[0px_8px_24px_rgba(149,157,165,0.2)] rounded-2xl shrink-0"
          >
            {/* Image */}
            <div className="w-[378px] h-[282px] rounded-t-2xl overflow-hidden">
              <img 
                src={blog.image} 
                alt={blog.title}
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            {/* Article Content */}
            <div className="flex flex-col items-start gap-4 w-[352px] h-[222px]">
              {/* Badge */}
              <div 
                className="flex flex-row justify-center items-center px-1.5 py-0.5 gap-2 h-[25px] rounded"
                style={{ backgroundColor: blog.badgeColor }}
              >
                <span 
                  className="text-white font-medium text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.badge}
                </span>
              </div>

              {/* Text Container */}
              <div className="flex flex-col items-start gap-3 w-full">
                {/* Title */}
                <h3 
                  className="text-[#3B3B3B] font-semibold text-[20px] leading-[24px] tracking-[-0.02em] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv01' on, 'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.title}
                </h3>
                
                {/* Description */}
                <p 
                  className="text-[#898989] font-normal text-[14px] leading-[20px] w-full"
                  style={{ 
                    fontFamily: "'Inter', sans-serif",
                    fontFeatureSettings: "'cv03' on, 'cv04' on"
                  }}
                >
                  {blog.description}
                </p>
              </div>

              {/* Footer */}
              <div className="flex flex-row justify-between items-center w-full">
                <span 
                  className="text-[#3B3B3B] font-normal text-[14px] leading-[21px]"
                  style={{ fontFamily: "'SF Pro Display', 'Inter', sans-serif" }}
                >
                  {blog.source}
                </span>
                
                <a 
                  href={blog.readMoreLink}
                  className="flex flex-row justify-center items-center gap-2 transition-all duration-150 hover:opacity-80 group"
                >
                  <span 
                    className="text-[#006633] font-medium text-[14px] leading-[20px]"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    Read More
                  </span>
                  <div className="relative w-2.5 h-4 flex items-center justify-center">
                    <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1.5 1L6.5 6L1.5 11" stroke="#006633" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
<Footer/>
</>
  )
}

export default BlogPost6